import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-diagnostic-form-logement',
  templateUrl: './participant-diagnostic-form-logement.component.html',
  styleUrls: ['./participant-diagnostic-form-logement.component.scss']
})
export class ParticipantDiagnosticFormLogementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
